const translation = {
  pageTitle: 'Hey, lass uns anfangen!👋',
  welcome: 'Willkommen bei Dify, bitte melde dich an, um fortzufahren.',
  email: 'E-Mail-Adresse',
  emailPlaceholder: 'Deine E-Mail',
  password: 'Passwort',
  passwordPlaceholder: 'Dein Passwort',
  name: 'Benutzername',
  namePlaceholder: 'Dein Benutzername',
  forget: 'Passwort vergessen?',
  signBtn: 'Anmelden',
  installBtn: 'Einrichten',
  setAdminAccount: 'Admin-Konto einrichten',
  setAdminAccountDesc: 'Maximale Berechtigungen für das Admin-Konto, das verwendet werden kann, um Anwendungen zu erstellen und LLM-Anbieter usw. zu verwalten.',
  createAndSignIn: 'Erstellen und anmelden',
  oneMoreStep: 'Nur noch ein Schritt',
  createSample: 'Basierend auf diesen Informationen erstellen wir eine Beispielanwendung für dich',
  invitationCode: 'Einladungscode',
  invitationCodePlaceholder: 'Dein Einladungscode',
  interfaceLanguage: 'Oberflächensprache',
  timezone: 'Zeitzone',
  go: 'Zu Dify gehen',
  sendUsMail: 'Sende uns deine Vorstellung per E-Mail, und wir bearbeiten die Einladungsanfrage.',
  acceptPP: 'Ich habe die Datenschutzbestimmungen gelesen und akzeptiere sie',
  reset: 'Bitte führe den folgenden Befehl aus, um dein Passwort zurückzusetzen',
  withGitHub: 'Mit GitHub fortfahren',
  withGoogle: 'Mit Google fortfahren',
  rightTitle: 'Das volle Potenzial von LLM ausschöpfen',
  rightDesc: 'Mühelos optisch ansprechende, bedienbare und verbesserbare KI-Anwendungen erstellen.',
  tos: 'Nutzungsbedingungen',
  pp: 'Datenschutzbestimmungen',
  tosDesc: 'Mit der Anmeldung stimmst du unseren',
  goToInit: 'Wenn du das Konto noch nicht initialisiert hast, gehe bitte zur Initialisierungsseite',
  dontHave: 'Hast du nicht?',
  invalidInvitationCode: 'Ungültiger Einladungscode',
  accountAlreadyInited: 'Konto bereits initialisiert',
  forgotPassword: 'Passwort vergessen?',
  resetLinkSent: 'Link zum Zurücksetzen gesendet',
  sendResetLink: 'Link zum Zurücksetzen senden',
  backToSignIn: 'Zurück zur Anmeldung',
  forgotPasswordDesc: 'Bitte geben Sie Ihre E-Mail-Adresse ein, um Ihr Passwort zurückzusetzen. Wir senden Ihnen eine E-Mail mit Anweisungen zum Zurücksetzen Ihres Passworts.',
  checkEmailForResetLink: 'Bitte überprüfen Sie Ihre E-Mails auf einen Link zum Zurücksetzen Ihres Passworts. Wenn er nicht innerhalb weniger Minuten erscheint, überprüfen Sie bitte Ihren Spam-Ordner.',
  passwordChanged: 'Jetzt anmelden',
  changePassword: 'Passwort ändern',
  changePasswordTip: 'Bitte geben Sie ein neues Passwort für Ihr Konto ein',
  invalidToken: 'Ungültiges oder abgelaufenes Token',
  confirmPassword: 'Passwort bestätigen',
  confirmPasswordPlaceholder: 'Bestätigen Sie Ihr neues Passwort',
  passwordChangedTip: 'Ihr Passwort wurde erfolgreich geändert',
  error: {
    emailEmpty: 'E-Mail-Adresse wird benötigt',
    emailInValid: 'Bitte gib eine gültige E-Mail-Adresse ein',
    nameEmpty: 'Name wird benötigt',
    passwordEmpty: 'Passwort wird benötigt',
    passwordInvalid: 'Das Passwort muss Buchstaben und Zahlen enthalten und länger als 8 Zeichen sein',
    passwordLengthInValid: 'Das Passwort muss mindestens 8 Zeichen lang sein',
    registrationNotAllowed: 'Konto nicht gefunden. Bitte wenden Sie sich an den Systemadministrator, um sich zu registrieren.',
  },
  license: {
    tip: 'Bevor du mit Dify Community Edition beginnst, lies die',
    link: 'Open-Source-Lizenz',
  },
  join: 'Beitreten',
  joinTipStart: 'Lade dich ein, dem',
  joinTipEnd: 'Team auf Dify beizutreten',
  invalid: 'Der Link ist abgelaufen',
  explore: 'Dify erkunden',
  activatedTipStart: 'Du bist dem',
  activatedTipEnd: 'Team beigetreten',
  activated: 'Jetzt anmelden',
  adminInitPassword: 'Admin-Initialpasswort',
  validate: 'Validieren',
  sso: 'Mit SSO fortfahren',
  checkCode: {
    didNotReceiveCode: 'Sie haben den Code nicht erhalten?',
    verificationCodePlaceholder: 'Geben Sie den 6-stelligen Code ein',
    checkYourEmail: 'Überprüfen Sie Ihre E-Mails',
    verify: 'Überprüfen',
    verificationCode: 'Verifizierungscode',
    useAnotherMethod: 'Verwenden Sie eine andere Methode',
    validTime: 'Beachten Sie, dass der Code 5 Minuten lang gültig ist',
    emptyCode: 'Code ist erforderlich',
    tips: 'Wir senden einen Verifizierungscode an <strong>{{email}}</strong>',
    invalidCode: 'Ungültiger Code',
    resend: 'Wieder senden',
  },
  or: 'ODER',
  back: 'Zurück',
  changePasswordBtn: 'Festlegen eines Kennworts',
  enterYourName: 'Bitte geben Sie Ihren Benutzernamen ein',
  setYourAccount: 'Richten Sie Ihr Konto ein',
  sendVerificationCode: 'Verifizierungscode senden',
  useVerificationCode: 'Verifizierungscode verwenden',
  withSSO: 'Mit SSO fortfahren',
  resetPasswordDesc: 'Geben Sie die E-Mail-Adresse ein, mit der Sie sich bei Dify angemeldet haben, und wir senden Ihnen eine E-Mail zum Zurücksetzen des Passworts.',
  continueWithCode: 'Fahren Sie mit dem Code fort',
  resetPassword: 'Passwort zurücksetzen',
  backToLogin: 'Zurück zum Login',
  noLoginMethodTip: 'Wenden Sie sich an den Systemadministrator, um eine Authentifizierungsmethode hinzuzufügen.',
  usePassword: 'Passwort verwenden',
  noLoginMethod: 'Authentifizierungsmethode nicht konfiguriert',
  licenseExpired: 'Lizenz abgelaufen',
  licenseLostTip: 'Fehler beim Verbinden des Dify-Lizenzservers. Wenden Sie sich an Ihren Administrator, um Dify weiterhin zu verwenden.',
  licenseInactive: 'Lizenz inaktiv',
  licenseInactiveTip: 'Die Dify Enterprise-Lizenz für Ihren Arbeitsbereich ist inaktiv. Wenden Sie sich an Ihren Administrator, um Dify weiterhin zu verwenden.',
  licenseExpiredTip: 'Die Dify Enterprise-Lizenz für Ihren Arbeitsbereich ist abgelaufen. Wenden Sie sich an Ihren Administrator, um Dify weiterhin zu verwenden.',
  licenseLost: 'Lizenz verloren',
  webapp: {
    noLoginMethod: 'Authentifizierungsmethode ist nicht für die Webanwendung konfiguriert',
    noLoginMethodTip: 'Bitte kontaktieren Sie den Systemadministrator, um eine Authentifizierungsmethode hinzuzufügen.',
    disabled: 'Die Webanmeldeauthentifizierung ist deaktiviert. Bitte kontaktieren Sie den Systemadministrator, um sie zu aktivieren. Sie können versuchen, die App direkt zu verwenden.',
  },
}

export default translation
